import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

interface QuizScoreBoxProps {
  score: number;
  total: number;
}

const QuizScoreBox: React.FC<QuizScoreBoxProps> = ({ score, total }) => (
  <Box
    sx={{
      position: 'fixed',
      top: 40,
      right: 'calc(50vw - 380px)',
      background: '#fff',
      borderRadius: '50%',
      boxShadow: 4,
      width: 64,
      height: 64,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      border: '3px solid #a3c9f9',
    }}
  >
    <Typography
      variant="h5"
      sx={{
        fontWeight: 700,
        color: 'primary.main',
        lineHeight: 1,
        fontFamily: '"Baloo 2", Arial, sans-serif',
      }}
    >
      {score}
    </Typography>
    <Divider sx={{ width: 32, bgcolor: 'primary.main', my: 0.5 }} />
    <Typography
      variant="h5"
      sx={{
        fontWeight: 700,
        color: 'primary.main',
        lineHeight: 1,
        fontFamily: '"Baloo 2", Arial, sans-serif',
      }}
    >
      {total}
    </Typography>
  </Box>
);

export default QuizScoreBox;